import type { User } from '../../types/auth';
import { getMockUserList, MOCK_DELAY_MS } from '../../constants/mockUsers';
import {
  AdminCommunicationPayload,
  AdminCourse,
  AdminCoursePayload,
  AdminOrder,
  AdminStats,
} from '../../types/admin';
import { MOCK_ORDERS } from '../../constants/mockDashboard';
import { MOCK_COURSES as MOCK_CART_COURSES } from '../../constants/mockCourses';

const delay = (ms = MOCK_DELAY_MS) => new Promise((r) => setTimeout(r, ms));

const MOCK_STATS: AdminStats = {
  totalUsers: 142,
  activeUsers: 98,
  totalRevenue: 8430,
  revenueThisMonth: 1260,
  totalOrders: 187,
  ordersThisMonth: 23,
  activeCourses: 3,
  weeklySignups: [4, 7, 3, 9, 5, 6, 8],
  monthlySales: [980, 1120, 870, 1340, 990, 1260],
  courseEnrollments: [
    { courseId: 'be-smart', title: 'Be Smart', count: 98 },
    { courseId: 'postura-pro', title: 'Postura Pro', count: 54 },
    { courseId: 'core-reset', title: 'Core Reset', count: 35 },
  ],
};

// Corsi admin — deriva da MOCK_COURSES (carrello) + enrollments fittizi.
let mockAdminCourses: AdminCourse[] = MOCK_CART_COURSES.map((c) => ({
  id: c.id,
  title: c.title,
  subtitle: c.subtitle ?? null,
  description: null,
  imageUrl: c.imageUrl ?? null,
  price: c.price ?? null,
  enrollments:
    MOCK_STATS.courseEnrollments.find((e) => e.courseId === c.id)?.count ?? 0,
}));

export const adminMock = {
  getStats: async (): Promise<AdminStats> => {
    // TODO: replace → GET /api/admin/stats
    await delay();
    return MOCK_STATS;
  },

  getUsers: async (): Promise<User[]> => {
    // TODO: replace → GET /api/admin/users
    await delay();
    return getMockUserList();
  },

  getUser: async (userId: string): Promise<User> => {
    // TODO: replace → GET /api/admin/users/:id
    await delay();
    const users = getMockUserList();
    const user = users.find((u: User) => u.id === userId);
    if (!user) throw new Error('Utente non trovato.');
    return user;
  },

  blockUser: async (_userId: string, _blocked: boolean): Promise<void> => {
    // TODO: replace → PATCH /api/admin/users/:id/block
    await delay();
  },

  deleteUser: async (_userId: string): Promise<void> => {
    // TODO: replace → DELETE /api/admin/users/:id
    await delay();
  },

  resetUserPassword: async (_userId: string): Promise<void> => {
    // TODO: replace → POST /api/admin/users/:id/reset-password
    await delay();
  },

  getOrders: async (): Promise<AdminOrder[]> => {
    await delay();
    return MOCK_ORDERS;
  },

  sendCommunication: async (
    _payload: AdminCommunicationPayload
  ): Promise<void> => {
    await delay(1200);
  },

  getCourses: async (): Promise<AdminCourse[]> => {
    // TODO: replace → GET /api/admin/courses
    await delay();
    return mockAdminCourses;
  },

  createCourse: async (payload: AdminCoursePayload): Promise<AdminCourse> => {
    // TODO: replace → POST /api/admin/courses
    await delay();
    const course: AdminCourse = {
      id: payload.id,
      title: payload.title,
      subtitle: payload.subtitle ?? null,
      description: payload.description ?? null,
      imageUrl: payload.imageUrl ?? null,
      price: payload.price ?? null,
      enrollments: 0,
    };
    mockAdminCourses = [...mockAdminCourses, course];
    return course;
  },

  updateCourse: async (
    id: string,
    payload: Partial<AdminCoursePayload>
  ): Promise<AdminCourse> => {
    // TODO: replace → PATCH /api/admin/courses/:id
    await delay();
    let updated: AdminCourse | undefined;
    mockAdminCourses = mockAdminCourses.map((c) => {
      if (c.id !== id) return c;
      updated = { ...c, ...payload };
      return updated;
    });
    if (!updated) throw new Error('Corso non trovato.');
    return updated;
  },
};
